import {
  Anchor,
  Button,
  Icon,
  InfoCircleHollowSVG,
  TooltipDialog,
} from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";
import {
  toolTipCss,
  toolTipIconCss,
  toolTipWrapperCss,
} from "./LevelToolTipDialog.style";

const TooltipDialogWithTrackEvent = withTrackEvent(TooltipDialog);
const AnchorWithTrackEvent = withTrackEvent(Anchor);

const propTypes = {
  assignmentId: PropTypes.string,
  currentContentLevelId: PropTypes.string,
};

const TOOLTIP_COPY = (
  <p>
    <AnchorWithTrackEvent
      actionName={actionNames.navigate}
      actionPrefix={actionPrefixes.initiate}
      dataProps={{
        "data-qa-selector": "lexile-levels-tooltip-support-article-link",
      }}
      href="https://support.newsela.com/article/student-reading-level/#the-teachers-role"
      isInline
      objectType={objectTypes.user}
      streamProperties={{
        description: "User clicked tooltip to learn more about Lexile Levels",
      }}
    >
      Read this support article
    </AnchorWithTrackEvent>
    for guidance on when to use Newsela's recommended Lexile Level® versus a
    specific grade/ Lexile Level.
  </p>
);

const LevelTooltipDialog = ({ assignmentId, currentContentLevelId }) => {
  return (
    <TooltipDialogWithTrackEvent
      __cssFor={toolTipCss}
      body={<div css={toolTipWrapperCss}>{TOOLTIP_COPY}</div>}
      buttonContents={
        <Icon
          ariaProps={{ "aria-hidden": false }}
          isDecorative={false}
          size={Icon.sizes.md}
          SvgComponent={InfoCircleHollowSVG}
          title="More information on lexile levels."
          __cssFor={{ root: toolTipIconCss }}
        />
      }
      buttonProps={{ flavor: Button.flavors.incognito }}
      dataProps={{
        "data-qa-selector": "hide-lexile-level-from-students-tool-tip-dialog",
      }}
      dialogAriaProps={{
        "aria-label": "More information on lexile levels.",
      }}
      placement="top"
      // tracking props
      objectType={objectTypes.assignment}
      actionPrefix={actionPrefixes.initiate}
      actionName={actionNames.interact}
      streamProperties={{
        content_id: currentContentLevelId,
        content_type: "Article",
        description: "Open hide lexile level from students tooltip",
        objectId: assignmentId,
      }}
    />
  );
};

LevelTooltipDialog.propTypes = propTypes;

export default LevelTooltipDialog;
